import API_ENDPOINTS from '../../endpoints/apiEndpoints';
import apiClient from '../../apiClient'; // API 클라이언트
import { BaseResponse } from '../UtilsInterface';
import {
  MemberAccountResponse,
  ResetPasswordRequest,
  UpdateSellerAccountRequest,
  UpdateBuyerAccountRequest,
  DeleteMemberAccountRequest,
} from './AccountInterfaces';

const AccountService = {
  // 회원 정보 조회
  getMemberAccount: async (): Promise<BaseResponse<MemberAccountResponse>> => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.get_account());
      return response.data;
    } catch (error) {
      console.error('회원 정보 조회 실패:', error);
      throw error;
    }
  },

  // 회원 정보 수정
  updateBuyerAccount: async (
    data: UpdateBuyerAccountRequest
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.update_buyer_account(),
        data
      );
      return response.data;
    } catch (error) {
      console.error('회원 정보 수정 실패:', error);
      throw error;
    }
  },
  // 회원 정보 수정
  updateSellerAccount: async (
    data: UpdateSellerAccountRequest
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.update_seller_account(),
        data
      );
      return response.data;
    } catch (error) {
      console.error('회원 정보 수정 실패:', error);
      throw error;
    }
  },

  // 회원 탈퇴
  deleteMemberAccount: async (
    data: DeleteMemberAccountRequest
  ): Promise<BaseResponse<void>> => {
    try {
      const response = await apiClient.request({
        method: 'DELETE', // DELETE 메서드 지정
        url: API_ENDPOINTS.delete_account(), // API 엔드포인트
        data, // body에 데이터 포함
      });

      // 공통 데이터 제거
      localStorage.clear();
      sessionStorage.clear();

      // 쿠키 리셋
      document.cookie.split(';').forEach((cookie) => {
        const [name] = cookie.split('=');
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      });
      return response.data; // 응답 데이터 반환
    } catch (error) {
      console.error('회원 탈퇴 실패:', error);
      throw error; // 에러 다시 던지기
    }
  },

  // 비밀번호 재설정
  resetPassword: async (
    data: ResetPasswordRequest
  ): Promise<BaseResponse<string>> => {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.reset_password(),
        data
      );
      return response.data;
    } catch (error) {
      console.error('비밀번호 재설정 실패:', error);
      throw error;
    }
  },
};

export default AccountService;
